/*
 *
 * BlockedModal
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 05-Sep-2024
*/

import BlockedModal from './BlockedModalContainer'

export default BlockedModal
